import { render } from "./IdeaForm.vue?vue&type=template&id=4f1a660b"
import script from "./IdeaForm.vue?vue&type=script&lang=js"
export * from "./IdeaForm.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__